import React from 'react';
import { Alert } from 'antd';
import { Wrapper, Spin } from './ContentWrapper.styled';

interface Props {
  children: React.ReactNode;
  isLoading?: boolean;
  error?: unknown | string;
  className?: string;
}

export default function ContentWrapper({ children, isLoading = false, error, className }: Props) {
  return (
    <Wrapper className={className}>
      {(() => {
        if (isLoading) return (
          <Spin size="large" />
        );

        if (error) return (
          <Alert
            type="error"
            showIcon
            message="Произошла ошибка при загрузке данных"
            description={error}
          />
        );

        return children;
      })()}
    </Wrapper>
  );
}
